export default "__VITE_ASSET__BaA6tWEn__"